import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getVisibleNumericalSelectedParametersNames } from 'store/dataset';

import OneSampleTComponent from './Component';
import { setMeansOneSampleT, setNumericalRowDataSet, getNumericalRowDataSet } from 'store/form/inferentialStatistics';
import { getOptionListForDropDown } from 'calculators/inferentialStatistics/oneSampleT';
import { valueOneSampleT } from '../defaultValueForProcedures';

class OneSampleTContainer extends React.PureComponent {
  getNumericalOptionsDataSet = () => {
    const { numericalSelectedParametersNames, isFrequencyTable } = this.props;
    return getOptionListForDropDown({
      selectedParametersNames: numericalSelectedParametersNames,
      isFrequencyTable
    });
  };

  handleNumericalDropDownDataSet = (_, newValue) => {
    this.props.handleNumericalDropDownDataSet(newValue);
  };

  render () {
    return (
      <OneSampleTComponent
        onGenerateMeanDataSet={this.handleNumericalDropDownDataSet}
        onHandleInputs={this.props.handleInputs}
        numericalOptionsDataSet={this.getNumericalOptionsDataSet()}
      />
    );
  }
}

OneSampleTContainer.propTypes = {
  numericalSelectedParametersNames: PropTypes.arrayOf(PropTypes.string),
  handleNumericalDropDownDataSet: PropTypes.func.isRequired,
  handleInputs: PropTypes.func.isRequired,
  isFrequencyTable: PropTypes.bool.isRequired
};

const mapStateToProps = state => ({
  numericalSelectedParametersNames: getVisibleNumericalSelectedParametersNames(
    state
  )
});

const mapDispatchToProps = {
  handleNumericalDropDownDataSet: value => (dispatch, getState) => {
    const state = getState();
    const {
      sampleSize,
      sampleMean,
      standardDeviation
    } = valueOneSampleT;
    const { numericalSummary } = state.dataset.summary;
    let valueDataSet = numericalSummary[value];
    if (!value) {
      valueDataSet = {
        mean: sampleMean,
        count: sampleSize,
        sampleStandardDeviation: standardDeviation
      };
    }
    setMeansOneSampleT(valueDataSet)(dispatch);
  },
  handleInputs: () => (dispatch, getState) => {
    const state = getState();
    const oneSampleTDropDown = getNumericalRowDataSet(state);
    if (oneSampleTDropDown) {
      dispatch(setNumericalRowDataSet(valueOneSampleT.numericalRowDataSet));
    }
  }
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OneSampleTContainer);
